import { FC } from 'react';

import _ from 'lodash';
import { useFormContext } from 'react-hook-form';

import { YES_NO_OPTIONS } from 'constants/common';
import { translate } from 'utils';

import { FormLabel } from '../FormLabel/FormLabel';
import RhfRadioGroup from '../RadioGroup/RhfRadioGroup/RhfRadioGroup';
import { RHFTextArea } from '../RHFTextArea/RHFTextArea';

const DEFAULT_FIELD_PREFIX =
  'treatmentSpecifications.ZenClearUltra.additionalAppliances';

interface Props {
  isDisabled?: boolean;
  fieldPrefix?: string;
  className?: string;
  label?: string;
}

const AdditionalAppliances: FC<Props> = ({
  isDisabled,
  fieldPrefix = DEFAULT_FIELD_PREFIX,
  className,
  label = translate('prescription.step18_additional_appliances')
}) => {
  const {
    watch,
    formState: { errors }
  } = useFormContext();
  const watchIsRequired = watch(`${fieldPrefix}.isRequired`);
  const fieldError = _.get(errors, fieldPrefix);

  return (
    <div className='flex flex-col'>
      <FormLabel
        label={label}
        className={`md:text-17px mb-4 ${className}`}
        error={!!fieldError}
        name='additionalAppliances'
      />
      <RhfRadioGroup
        inputProps={{ disabled: isDisabled }}
        options={YES_NO_OPTIONS}
        name={`${fieldPrefix}.isRequired`}
        className='flex flex-row space-x-16'
        radioClassName='border-RADIO_BORDER'
        radioItemFont={`md:text-17px text-sm ${className}`}
      />
      {watchIsRequired === true && (
        <div className='bg-GRAY5 p-4 rounded-2xl mt-4 flex flex-col space-y-4'>
          <RHFTextArea
            title={translate('prescription.tads')}
            name={`${fieldPrefix}.tads`}
            autogrow
            inputProps={{
              disabled: isDisabled,
              placeholder: translate('settings.please_type_here')
            }}
            maxgrowHeight={260}
          />
          <RHFTextArea
            title={translate('prescription.sectional_braces')}
            name={`${fieldPrefix}.sectionalBraces`}
            className={className}
            autogrow
            inputProps={{
              disabled: isDisabled,
              placeholder: translate('settings.please_type_here')
            }}
            maxgrowHeight={260}
          />
          <RHFTextArea
            title={translate('prescription.other_appliances')}
            name={`${fieldPrefix}.otherAppliances`}
            className={className}
            autogrow
            inputProps={{
              disabled: isDisabled,
              placeholder: translate('settings.please_type_here')
            }}
            maxgrowHeight={260}
          />
        </div>
      )}
    </div>
  );
};

export default AdditionalAppliances;
